<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="visible" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="handleQuery">
        <a-row :gutter="10">
          <a-col :md="12" :sm="16">
            <a-form-item label="问题标题" prop="title">
              <a-input v-model="queryParam.title" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="resetQuery" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operations">
      <a-button type="primary" @click="$refs.problemCreateForm.handleAdd(surveyId)" v-hasPermi="['biz:surveyproblem:add']">
        <a-icon type="plus" />新增
      </a-button>
      <a-button type="primary" :disabled="single" @click="$refs.problemCreateForm.handleUpdate(undefined, ids)" v-hasPermi="['biz:surveyproblem:edit']">
        <a-icon type="edit" />修改
      </a-button>
      <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['biz:surveyproblem:remove']">
        <a-icon type="delete" />删除
      </a-button>
      <table-setting
        :style="{float: 'right'}"
        :table-size.sync="tableSize"
        v-model="columns"
        :refresh-loading="loading"
        @refresh="getList"/>
    </div>
    <problem-create-form
      ref="problemCreateForm"
      @ok="getList"
    />
    <option-index
      ref="optionIndex"
    />
    <!-- table区域-begin -->
    <div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :scroll="{ x: 800}"
        :bordered="tableBordered"
      >
        <a-input-number
          slot="sort"
          slot-scope="text, record"
          :min="0"
          :step="1"
          v-model="record.sort"
          @change="changeInput($event,record)" />
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['biz:surveyproblem:edit']" />
          <a @click="$refs.problemCreateForm.handleUpdate(record, undefined)" v-hasPermi="['biz:surveyproblem:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider v-if="record.type === 1 || record.type === 2" type="vertical" />
          <a v-if="record.type === 1 || record.type === 2" @click="$refs.optionIndex.handleQuery(record, undefined)">
            <a-icon type="edit" />设置选项
          </a>
          <a-divider type="vertical" v-hasPermi="['biz:surveyproblem:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['biz:surveyproblem:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </div>
    <!-- table区域-end -->
  </a-drawer>
  <!-- 表单区域 -->
</template>

<script>
import { tableMixin } from '@/store/table-mixin'
import ProblemCreateForm from './modules/ProblemCreateForm'
import OptionIndex from './optionIndex'
import { pageSurveyProblem, delSurveyProblem, updateSurveyProblem } from '@/api/biz/surveyProblem'

export default {
  name: 'ProblemIndex',
  mixins: [tableMixin],
  components: { ProblemCreateForm,OptionIndex },
  data() {
    return {
      description: '',
      screenWidth: 800,
      formTitle: '问题列表',
      visible: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      ids: [],
      model: {},
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      loading: false,
      surveyId: null,
      total: 0,
      queryParam: {
        title: null,
        surveyId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: function (type) {
            if (type === 1) {
              return '单选'
            } else if (type === 2) {
              return '多选'
            } else if (type === 3) {
              return '简述'
            }
          }
        },
        {
          title: '问题标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '30%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  computed: {},
  created() {
  },
  watch: {},
  methods: {
    changeInput(e, record) {
      this.updateSurveyProblemData(record)
    },
    updateSurveyProblemData(record) {
      updateSurveyProblem(record).then(res => {
        console.log(res)
        this.$message.success('操作成功！')
      })
    },
    getList() {
      this.loading = true
      this.queryParam.surveyId = this.surveyId
      pageSurveyProblem(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery(record) {
      if (record.id) {
        this.surveyId = record.id
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.visible = true
    },
    resetQuery() {
      this.queryParam = {
        title: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onClose() {
      this.visible = false
      this.form.resetFields()
      this.list = []
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delSurveyProblem(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
